import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getAdminTickets } from '../../../../services/tickets/admin';

export const ticketsQueryKeys = {
  all: ['tickets'],
  list: (params) => [...ticketsQueryKeys.all, 'list', params],
};

export function useTicketsQuery(params) {
  return useQuery({
    queryKey: ticketsQueryKeys.list(params),
    queryFn: () => getAdminTickets(params),
    placeholderData: keepPreviousData,
  });
}
